import { render, staticRenderFns } from "./ArticlesModal.vue?vue&type=template&id=2452a9df&scoped=true&"
import script from "./ArticlesModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./ArticlesModal.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2452a9df",
  null
  
)

export default component.exports